export const randomStr = (length) => {
  let randomText = "";
  const randomString =
    "ABCDEFGHIJKLMNPPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890";
  for (let i = 0; i < length; i++) {
    randomText += randomString.charAt(
      Math.floor(Math.random() * randomString.length)
    );
  }
  return randomText;
};

/**
 * tabel serial nummber add func
 * @param {page number} page
 * @param {per page size} pageSize
 * @param {data arr} formvalue
 * @returns add sNo field and return new array
 */
export const tableId = (page, pageSize, formvalue) => {
  for (let i in formvalue) {
    formvalue[i]["sNo"] = page * pageSize - pageSize + 1 + +i;
  }
  return formvalue;
};
